<template>
    <div class="grid">
        <div class="col-12">
            <Message :closable="false"
                >TOTAL DESPESAS: <strong>{{ $numeral(valorTotal).format('$0,0.00') }}</strong></Message
            >
            <tabela
                :data="despesas"
                dataKey="convenioDespesaId"
                :globalFilterFields="['acao', 'descricao', 'idMov']"
                stateKey="dt-rm-convenios-execucao-direta-despesas"
            >
                <template #botoes>
                    <BtnRelatorioConsolidado :convenio-id="$route.params.id" />
                </template>
                <template #conteudo>
                    <Column field="fornecedor" header="Fornecedor" :sortable="true">
                        <template #body="slotProps"> {{ slotProps.data.fornecedor }} </template>
                    </Column>
                    <Column field="Mês de Referência" header="Mês de Referência" :sortable="true">
                        <template #body="slotProps"> {{ $dateFormat(slotProps.data.dataDespesa, 'MMMM') }} </template>
                    </Column>
                    <Column field="dataEmissao" header="Data Emissão" :sortable="true">
                        <template #body="slotProps"> {{ $dateFormat(slotProps.data.dataEmissao, 'DD/MM/YYYY') }} </template>
                    </Column>
                    <Column field="dataBaixa" header="Data Baixa" :sortable="true">
                        <template #body="slotProps"> {{ $dateFormat(slotProps.data.dataBaixa, 'DD/MM/YYYY') }} </template>
                    </Column>
                    <Column field="acao" header="Ação" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.acao }}
                        </template>
                    </Column>
                    <Column field="valor" header="Valor" :sortable="true">
                        <template #body="slotProps">
                            <div class="white-space-nowrap text-right">
                                <span>{{ $numeral(slotProps.data.valor).format('$0,0.00') }}</span>
                            </div>
                        </template>
                    </Column>
                    <Column field="percentualSebrae" header="Perc. Sebrae" :sortable="true">
                        <template #body="slotProps">
                            <div class="white-space-nowrap text-right">
                                <span>{{ $numeral(slotProps.data.percentualSebrae).format('0,0.00') }}%</span>
                            </div>
                        </template>
                    </Column>
                    <Column field="percentualConvenente" header="Perc. Convenente" :sortable="true">
                        <template #body="slotProps">
                            <div class="white-space-nowrap">
                                <span>{{ $numeral(slotProps.data.percentualConvenente).format('0,0.00') }}%</span>
                            </div>
                            <div class="">
                                <span v-if="slotProps.data.idReconhecimentoReceita"
                                    ><small
                                        ><strong>({{ slotProps.data.idReconhecimentoReceita }})</strong></small
                                    ></span
                                >
                                <span v-if="!slotProps.data.idReconhecimentoReceita"
                                    ><small><strong>Reconhecimento de receita não realizada</strong></small></span
                                >
                            </div>
                        </template>
                    </Column>
                    <Column header="Ações" :exportable="false" style="min-width: 8rem">
                        <template #body="slotProps">
                            <BtnRelatorioIndividual :despesa="slotProps.data" :convenio-id="$route.params.id" />
                        </template>
                    </Column>
                </template>
            </tabela>
        </div>
    </div>
</template>

<script>
import Services from '../../despesas/services';
import RelatorioServices from './services';
import BtnRelatorioConsolidado from './BtnRelatorioConsolidado.vue';
import BtnRelatorioIndividual from './BtnRelatorioIndividual.vue';

export default {
    props: {
        convenio: {
            type: Object,
        },
    },

    components: {
        BtnRelatorioConsolidado,
        BtnRelatorioIndividual,
    },

    data() {
        return {
            despesas: null,
            valorTotal: 0,
            percentualSebrae: 0,
            percentualConvenente: 0,
        };
    },

    computed: {},

    methods: {
        obterServices() {
            return Services;
        },
        obterRelatorioServices() {
            return RelatorioServices;
        },

        obterDespesas() {
            this.$store.dispatch('addRequest');
            Services.obterDespesas(this.$route.params.id).then((response) => {
                if (response?.success) {
                    this.despesas = [...response.data.despesas];
                    this.valorTotal = response.data.valorTotal;
                } else {
                    this.despesas = null;
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    watch: {
        convenio() {
            if (this.convenio) {
                this.obterDespesas();
            }
        },
    },
};
</script>
